<template>
<div>  
    <!-- published Section -->
    <section class="page-section bg-color-dynamic" id="publishedsection">
        <!-- muncul pas gede aja -->
        <div class="container d-sm-none d-lg-block d-none d-md-block">
            <h1 class="text-center mt-0 section-title">
                {{ $t('textPublishedBy1') }}
            </h1>
            <hr class="divider my-4" style="visibility:hidden;margin:0.5rem!important;">
            <div dir="ltr" class="d-flex flex-row flex-wrap justify-content-center align-items-center" style="gap: 0.25rem;">
                <a v-for="[index, pub] of lists.entries()" :href="pub.url" target="_blank">
                    <img v-lazy="pub.img" alt="pub" :class="[index == 4 ? 'detik-special' : '', index == 9 ? 'tvone-special' : '']"/>
                    <span v-lazy:background-image="pub.img"></span>
                </a>
            </div>
        </div>

        <!-- muncul pas kecil aja -->
        <div class="container d-block d-md-none">
            <h1 class="text-center mt-0 section-title">
                {{ $t('textPublishedBy1') }}
            </h1>
            <div dir="ltr" class="d-flex flex-row flex-wrap justify-content-center align-items-center" style="gap: 0.25rem; margin-top: 3rem;">
                <a v-for="listIndex in listsMobileOnlyIndex" :href="lists[listIndex].url" target="_blank" class="d-inline-flex flex-row justify-content-center">
                    <img v-lazy="lists[listIndex].img" alt="pub" :class="[listIndex == 4 ? 'detik-special' : '', listIndex == 9 ? 'tvone-special' : '']"/>
                    <span v-lazy:background-image="lists[listIndex].img"></span>
                </a>
            </div>
        </div>
        <div class="d-flex flex-row justify-content-center" style="margin: 2rem 0;">
            <span class="many-more text-roboto" v-t="{path: 'textPublishedBy2'}"></span>
        </div>
    </section>
</div>
</template>

<script>
import { createImageObject } from '@/utils/utils';

import imgPub1 from '@/assets/img/publishedby/pub1.png';
import imgPub2 from '@/assets/img/publishedby/pub2.png';
import imgPub5 from '@/assets/img/publishedby/pub5.png';
import imgPub8 from '@/assets/img/publishedby/pub8.png';
import imgPub9 from '@/assets/img/publishedby/pub9.png';
import imgPub11 from '@/assets/img/publishedby/pub11.png';
import imgPub12 from '@/assets/img/publishedby/pub12.png';
import imgPub13 from '@/assets/img/publishedby/pub13.png';
import imgPubTVOne from '@/assets/img/publishedby/pubTVOne.png';
import imgPubCeritaUntungs from '@/assets/img/publishedby/pubCeritaUntungs.webp';
import imgPubTheSungkars from '@/assets/img/publishedby/pubTheSungkars.webp';

export default {
   name: 'PublishedSection',
   data() {
    return {
        lists: [
            {
                img: createImageObject(imgPubCeritaUntungs),
                url: 'https://link.learn-quran.co/learnquran-cerita-untungs',
            },
            {
                img: createImageObject(imgPubTheSungkars),
                url: 'https://link.learn-quran.co/learnquran-the-sungkars',
            },
            {
                img: createImageObject(imgPub1),
                url: 'https://learn-quran.co/link/pubAmustTajwid2018',
            },
            {
                img: createImageObject(imgPub2),
                url: 'https://learn-quran.co/link/pubBekrafArchive2018',
            },
            {
                img: createImageObject(imgPub5),
                url: 'https://learn-quran.co/link/pubDetikVideoBekrafSyariah',
            },
            {
                img: createImageObject(imgPub8),
                url: 'https://learn-quran.co/link/pubKompasBelajarVirtual',
            },
            {
                img: createImageObject(imgPub9),
                url: 'https://learn-quran.co/link/pubMNCLiveChatYouTube',
            },
            {
                img: createImageObject(imgPub11),
                url: 'https://learn-quran.co/link/pubRepublikaLearnQuranSmartphone',
            },           
            {
                img: createImageObject(imgPub13),
                url: 'https://learn-quran.co/link/pubSWABekrafDeureuham2019',
            },
            {
                img: createImageObject(imgPubTVOne),
                url: 'https://link.learn-quran.co/learn-quran-co-and-tv-one',
            },
        ],
        listsMobileOnlyIndex: [0, 1, 4, 5, 9, 2, 6],
    }
  },
    mounted() {
       this.$nextTick(() => {
            // alert('published section finish loaded')
            this.$emit('isPartnerSection', 'partnerSectionActive')
        })
    },
}
</script>

<style scoped>

.detik-special {
    max-height: 2.5rem;
}
@media (min-width: 320px) {
    .detik-special {
        max-height: 2.5rem;
    }
}

.tvone-special {
    max-height: 2.5rem;
}

.rounded-lg {
    border-radius: .5rem!important;
}
img {
    max-height:5rem;    
    /* max-height: 3.7rem; */
    max-width: 100%;
    transition: 0.3s;
}

.col-fix-width {
    /* min-width: max-content; */
}

img:hover {    
    opacity: 0.5;
}

.section-title {
    font-family: 'QuattrocentoRegular', 'Rubik', sans-serif;
    /* font-weight: 0!important; */
    color:#053448;
}
.pub-half {
    max-width: 45%!important;
}
.many-more {
    font-weight: 400;
    font-size: 1.75rem;
    color: #053448;
}

#publishedsection {
    padding-bottom: 0.1rem!important;
}

.no-padding-col {
    padding: unset;
}

.bg-color-dynamic {
    --afterclick-bg-color: white;
    background-color: var(--afterclick-bg-color) !important;

}
body.dark .bg-color-dynamic {
  --afterclick-bg-color: #dcdcdc!important;
}

body.force-dark .bg-color-dynamic {
  --afterclick-bg-color: #dcdcdc!important;
}

@media (min-width: 992px) {
    .many-more {
        font-size: 1.5rem;
    }
}
</style>
